export const weekdayToJs = {
  'Thứ 2': 1, 'Thứ 3': 2, 'Thứ 4': 3, 'Thứ 5': 4,
  'Thứ 6': 5, 'Thứ 7': 6, 'Chủ nhật': 0,
};

export const jsToWeekday = {
  1: 'Thứ 2', 2: 'Thứ 3', 3: 'Thứ 4', 4: 'Thứ 5',
  5: 'Thứ 6', 6: 'Thứ 7', 0: 'Chủ nhật',
};

export const getDeliveryDate = (cycleStartDate, weekIdx, totalWeeks, deliveryDay) => {
  if (!cycleStartDate || !deliveryDay || !(deliveryDay in weekdayToJs)) return null;

  const start = new Date(cycleStartDate + 'T00:00:00');
  if (isNaN(start.getTime())) return null;

  const today = new Date();
  today.setHours(0, 0, 0, 0);

  const cycleDays = totalWeeks * 7;
  const elapsed = Math.floor((today - start) / (1000 * 60 * 60 * 24));

  const currentCycle = Math.max(0, Math.floor(elapsed / cycleDays));
  const cycleStart = new Date(start);
  cycleStart.setDate(cycleStart.getDate() + currentCycle * cycleDays);

  // Align to calendar week: find Monday of the week containing cycleStart
  const dow = cycleStart.getDay();
  const mondayOffset = dow === 0 ? -6 : 1 - dow;
  const firstMonday = new Date(cycleStart);
  firstMonday.setDate(firstMonday.getDate() + mondayOffset);

  // Monday of the target week
  const weekStart = new Date(firstMonday);
  weekStart.setDate(weekStart.getDate() + weekIdx * 7);

  // Delivery date within this calendar week (offset from Monday)
  const targetDay = weekdayToJs[deliveryDay];
  const dayOffset = (targetDay - 1 + 7) % 7;
  const deliveryDate = new Date(weekStart);
  deliveryDate.setDate(deliveryDate.getDate() + dayOffset);

  // Skip if before cycle start (partial first week)
  if (deliveryDate < cycleStart) return null;

  return deliveryDate;
};

export const formatDate = (date) => {
  if (!date) return null;
  const d = date.getDate().toString().padStart(2, '0');
  const m = (date.getMonth() + 1).toString().padStart(2, '0');
  return `${d}/${m}`;
};

export const toIsoDate = (date) => {
  if (!date) return null;
  const y = date.getFullYear();
  const m = (date.getMonth() + 1).toString().padStart(2, '0');
  const d = date.getDate().toString().padStart(2, '0');
  return `${y}-${m}-${d}`;
};
